import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TemPermissaoDirective } from '../../directives/tem-permissao.directive';

@Component({
  selector: 'app-botao-voltar',
  standalone: true,
  imports: [CommonModule, ButtonModule, TemPermissaoDirective],
  templateUrl: './botao-voltar.component.html',
  styleUrl: './botao-voltar.component.scss',
})
export class BotaoVoltarComponent {
  @Input() urlDestino?: string;
  @Input() permissao?: string | string[];
  @Input() texto = 'Voltar';
  @Input() ariaLabel = 'Voltar para listagem';
  @Input() controlarVoltar = false;

  @Output() aoVoltar = new EventEmitter<void>();

  constructor(
    private readonly router: Router,
  ) {}

  protected voltar(): void {
    if (this.controlarVoltar) {
      this.aoVoltar.emit();
      return;
    }

    if (this.urlDestino) {
      void this.router.navigateByUrl(this.urlDestino);
      return;
    }
    const rotaListagem = this.resolverRotaListagem();
    void this.router.navigateByUrl(rotaListagem);
  }

  private resolverRotaListagem(): string {
    const urlLimpa = this.router.url.split('?')[0].split('#')[0];
    const segmentos = urlLimpa.split('/').filter(Boolean);

    if (!segmentos.length) {
      return '/';
    }

    const ultimo = segmentos[segmentos.length - 1];
    const penultimo = segmentos[segmentos.length - 2];

    if (ultimo === 'novo' || ultimo === 'nova') {
      return `/${segmentos.slice(0, -1).join('/')}`;
    }

    if ((ultimo === 'editar' || ultimo === 'visualizar' || ultimo === 'analisar') && penultimo) {
      return `/${segmentos.slice(0, -2).join('/')}`;
    }

    if (/^\d+$/.test(ultimo) && segmentos.length > 1) {
      return `/${segmentos.slice(0, -1).join('/')}`;
    }

    return `/${segmentos.join('/')}`;
  }
}
